const GrpcWebStreamParser = require('./grpcwebstreamparser.js').default;

export const parse = response => {
  // console.log("grpcwebreadablestream [response]:", response);

  const parser = new GrpcWebStreamParser();
  var byteSource = new Uint8Array(
    /** @type {!ArrayBuffer} */(response));
  var messages = null;
  try {
    messages = parser.parse(byteSource);
  } catch (err) {
    console.error(err);
  }

  // console.log("grpcwebreadablestream [messages]:", messages);

  if (messages) {
    var FrameType = GrpcWebStreamParser.FrameType;
    for (var i = 0; i < messages.length; i++) {
      if (FrameType.DATA in messages[i]) {
        var data = messages[i][FrameType.DATA];
        // console.log("grpcwebreadablestream [parse]:", data);

        if (data)
          return data;
        else {
          console.error("coudn't parse response");
          return null;
        }
      }
    }
  }
}
